var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      staticClass: "ax-powerbar",
      style: _vm.additionalStyle,
      on: { mouseup: _vm.onPowerbarMouseUp }
    },
    [
      _c("ax-searchbar", {
        attrs: {
          clientViewPath: _vm.clientViewPath,
          classAgent: _vm.classAgent,
          fundSearchApiEndpoint: _vm.fundSearchApiEndpoint,
          accessToken: _vm.accessToken,
          enableHelpPanel: _vm.enableHelpPanel
        },
        on: {
          newFeatureToggled: _vm.toggled,
          searchBoxFocused: _vm.searchBoxFocused,
          navigate: _vm.navigate
        }
      }),
      _vm._v(" "),
      _c("powerbar-nav", {
        attrs: {
          entityChipData: _vm.entityChipData,
          menuBar: _vm.navData,
          eventsMenuBar: _vm.eventsData,
          username: _vm.username,
          baseUrl: _vm.baseUrl,
          homeUrl: _vm.homeUrl
        },
        on: { navigate: _vm.navigate }
      }),
      _vm._v(" "),
      _c("ax-sidebar", {
        attrs: {
          "enable-dap-sso": _vm.enableDapSso,
          integrationConfig: _vm.integrationConfig
        }
      }),
      _vm._v(" "),
      _c("settings-panel", { attrs: { username: _vm.username } }),
      _vm._v(" "),
      _c("help-panel")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }